import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'training_and_orientation'

export const dataPointDefinition = {
  retracedId: 'training_and_orientation',
  name: 'Training and orientation',
  description:
    'Refers to expenses for required trainings, including on-site job orientation and pre-departure or post-arrival orientation of newly recruited workers.',
  meta: {
    slcpMeta: {
      key: 'fl-4--2-6x',
      number: 'RH-REC-5-3',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'rh-rec-1',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],fl-4,Worker Only;Facility and Worker',
      machineShowHide: '[2],fl-4,2;3',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fl-4--2-6x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27140,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
